import React from "react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import I18n from "../../I18n";
import { stringifyFilter } from "colbi_web_ui/lib/utils";
import jsesc from "jsesc";
import { SovosBox, SovosButton, SovosIcon, SovosTypography } from "mosaic-react";
import { useTheme } from "mosaic-react/styles";
import { DocumentErrorFilled, ErrorOutlineOutlined } from "mosaic-react-icons";

const SubmitSalesInfo = (props) => {
    const { alternativeProps, value, modules } = props;
    const { params } = useGlobalValue();

    const { projectId, fiscalYear, importId, locale } = params;
    const projectFiscalYears = alternativeProps && alternativeProps.projectData;
    const fileToRedirect = projectFiscalYears && projectFiscalYears[fiscalYear];
    const file = (fileToRedirect || []).find(({ id }) => id === parseInt(importId));
    const localeToUse = locale || "en";

    const checkSubmissionModule = (modules || []).includes("submission_file");
    const theme = useTheme();
    const salesInformationValue = I18n.translate`${
        value === 2 ? "Submitting Data" : "Data not submitted"
    }`;
    const colorToDisplay = {
        0: theme.palette.error.light,
        2: theme.palette.success.light,
    };

    const showSubmitSalesInfoBanner = (checkSubmissionModule, importId, value) => {
        return checkSubmissionModule && importId !== "full" && value !== 1;
    };
    const showSubmitFileButton = (file, value) => {
        return file && file["id"] !== "full" && (value === null || value === 0);
    };

    return (
        <SovosBox
            sx={{
                maxWidth: "100% !important",
                width: "100% !important",
                margin: "0px 0px 30px 0px !important",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "small",
            }}
        >
            {showSubmitSalesInfoBanner(checkSubmissionModule, importId, value) ? (
                <SovosBox
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        backgroundColor: colorToDisplay[value || 0],
                        padding: "16px 24px",
                        borderRadius: `${theme.shape.borderRadiusSmall}`,
                        width: "100%",
                        boxSizing: "border-box",
                        marginTop: "-30px",
                    }}
                >
                    <SovosBox
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            paddingLeft: "9px !important",
                        }}
                    >
                        <SovosBox>
                            <SovosIcon>
                                {!value ? (
                                    <DocumentErrorFilled style={{ fill: "#072448" }} />
                                ) : (
                                    value === 2 && (
                                        <ErrorOutlineOutlined style={{ fill: "#072448" }} />
                                    )
                                )}
                            </SovosIcon>
                        </SovosBox>
                        <SovosBox sx={{ marginLeft: "8px" }}>
                            <SovosTypography children={salesInformationValue} variant={"span"} />
                        </SovosBox>
                    </SovosBox>
                    {showSubmitFileButton(file, value) ? (
                        <SovosButton
                            size="small"
                            variant="outlined"
                            color={theme.palette.common.black}
                            onClick={() => {
                                return (window.location.href = jsesc(
                                    `/${localeToUse}/${projectId}/${fiscalYear}/${importId}/repository/folders?filter=${stringifyFilter(
                                        [
                                            {
                                                column: "ID",
                                                filters: [{ value: `${importId}` }],
                                            },
                                        ],
                                    )}`,
                                ));
                            }}
                            children={I18n.translate`Submit File`}
                        />
                    ) : null}
                </SovosBox>
            ) : null}
        </SovosBox>
    );
};
export default SubmitSalesInfo;
